
import { Component, Mixins } from 'vue-property-decorator';
import AdvisorStudentCouponVouchers from '../../advisorSystem/widgets/StudentCouponVouchers.vue';
@Component({})
export default class StudentCouponVouchers extends Mixins(AdvisorStudentCouponVouchers) {}
